import { createTheme } from '@mui/material/styles';
import { colors } from '../assets/styles/theme';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: colors.primary.main,
            light: colors.primary.light,
            dark: colors.primary.dark,
            contrastText: colors.primary.contrastText,
        },
        secondary: {
            main: colors.secondary.main,
            light: colors.secondary.light,
            dark: colors.secondary.dark,
            contrastText: colors.secondary.contrastText,
        },
        background: {
            default: colors.background.default, // #0A1929
            paper: colors.background.paper,     // #132F4C
        },
        text: {
            primary: colors.text.primary,
            secondary: colors.text.secondary,
            disabled: colors.text.disabled,
        },
        error: {
            main: colors.error.main,
            light: colors.error.light,
            dark: colors.error.dark,
        },
        warning: {
            main: colors.warning.main,
            light: colors.warning.light,
            dark: colors.warning.dark,
        },
        info: {
            main: colors.info.main,
            light: colors.info.light,
            dark: colors.info.dark,
        },
        success: {
            main: colors.success.main,
            light: colors.success.light,
            dark: colors.success.dark,
        },
        divider: colors.divider,
        action: {
            active: colors.action.active,
            hover: colors.action.hover,
            selected: colors.action.selected,
            disabled: colors.action.disabled,
            disabledBackground: colors.action.disabledBackground,
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h1: { fontWeight: 700, fontSize: '3rem', lineHeight: 1.2 },
        h2: { fontWeight: 700, fontSize: '2.5rem', lineHeight: 1.3 },
        h3: { fontWeight: 600, fontSize: '2rem', lineHeight: 1.4 },
        h4: { fontWeight: 600, fontSize: '1.5rem', lineHeight: 1.4 },
        h5: { fontWeight: 600, fontSize: '1.25rem', lineHeight: 1.5 },
        h6: { fontWeight: 600, fontSize: '1rem', lineHeight: 1.5 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: {
        borderRadius: 12,
    },
    shadows: [
        'none',
        '0px 2px 4px rgba(0, 0, 0, 0.4)',
        '0px 4px 8px rgba(0, 0, 0, 0.4)',
        '0px 6px 12px rgba(0, 0, 0, 0.4)',
        '0px 8px 16px rgba(0, 0, 0, 0.4)',
        '0px 10px 20px rgba(0, 0, 0, 0.4)',
        '0px 12px 24px rgba(0, 0, 0, 0.4)',
        '0px 14px 28px rgba(0, 0, 0, 0.4)',
        '0px 16px 32px rgba(0, 0, 0, 0.4)',
        '0px 18px 36px rgba(0, 0, 0, 0.4)',
        '0px 20px 40px rgba(0, 0, 0, 0.4)',
        '0px 22px 44px rgba(0, 0, 0, 0.4)',
        '0px 24px 48px rgba(0, 0, 0, 0.4)',
        '0px 26px 52px rgba(0, 0, 0, 0.4)',
        '0px 28px 56px rgba(0, 0, 0, 0.4)',
        '0px 30px 60px rgba(0, 0, 0, 0.4)',
        '0px 32px 64px rgba(0, 0, 0, 0.4)',
        '0px 34px 68px rgba(0, 0, 0, 0.4)',
        '0px 36px 72px rgba(0, 0, 0, 0.4)',
        '0px 38px 76px rgba(0, 0, 0, 0.4)',
        '0px 40px 80px rgba(0, 0, 0, 0.4)',
        '0px 42px 84px rgba(0, 0, 0, 0.4)',
        '0px 44px 88px rgba(0, 0, 0, 0.4)',
        '0px 46px 92px rgba(0, 0, 0, 0.4)',
        '0px 48px 96px rgba(0, 0, 0, 0.4)',
    ],
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': { boxShadow: '0px 4px 12px rgba(0, 217, 255, 0.3)' },
                },
                contained: {
                    background: colors.gradient.primary,
                    '&:hover': { background: colors.gradient.secondary },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: colors.background.paper,
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    background: colors.gradient.dark,
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.5)',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: colors.background.paper,
                    borderRadius: 16,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'rgba(255, 255, 255, 0.23)' },
                        '&:hover fieldset': { borderColor: colors.primary.main },
                        '&.Mui-focused fieldset': { borderColor: colors.primary.main },
                    },
                },
            },
        },
    },
});

export default theme;
